// import dotenv from 'dotenv';

// dotenv.config({ silent: true });

/* eslint-disable no-nested-ternary */
const prod = {
  url: 'https://my-brain-explained-backend.onrender.com',
};

const staging = {
  url: 'https://my-brain-explained-backend-dev.onrender.com',
};

const dev = {
  url: 'http://localhost:9090',
};

// eslint-disable-next-line import/prefer-default-export
export const config = process.env.TARGET_ENV === 'production'
  ? prod
  : process.env.TARGET_ENV === 'staging'
    ? staging
    : dev;
